/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Button_CopiedInputs */

const en_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const zh_hans1_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

const pt_br2_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const es_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const fr_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const de_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert`)
};

const ru_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано`)
};

const it_copy_button_copied = /** @type {(inputs: Copy_Button_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Copy_Button_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const copy_button_copied = /** @type {((inputs?: Copy_Button_CopiedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Button_CopiedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_copy_button_copied(inputs)
	if (locale === "pt-BR") return pt_br2_copy_button_copied(inputs)
	if (locale === "es") return es_copy_button_copied(inputs)
	if (locale === "fr") return fr_copy_button_copied(inputs)
	if (locale === "de") return de_copy_button_copied(inputs)
	if (locale === "ru") return ru_copy_button_copied(inputs)
	if (locale === "it") return it_copy_button_copied(inputs)
	return en_copy_button_copied(inputs)
});